import { ORDER_TYPES } from 'nandos-middleware-api/model/food-basket'

/**
 * Converts a basket's order type (DELIVERY, COLLECTION etc) to a "key string" that can be used to retrieve the relevant i18n value,
 * Taking into account pseudo order types like "kerbside collection"
 */
export default function (basket) {
	switch(basket.orderType) {
    case ORDER_TYPES.DELIVERY: return 'delivery'
    case ORDER_TYPES.COLLECTION: return basket.kerbsideCollect ? 'kerbside' : 'collection'
    case ORDER_TYPES.EAT_IN: return 'eatIn'
  }
}